import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservationLecture/Load',
      params,
    });
  },
  // 取消預約
  CancelReservation(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationLecture/CancelReservation',
      data,
    });
  },
  // 報到
  Signup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationLecture/Signup',
      data,
      headers: { 'Content-Type': 'application/json-patch+json' },
    });
  },
  // 補簽到/取消簽到
  ChangeSignup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationLecture/ChangeSignup',
      data,
      headers: { 'Content-Type': 'application/json-patch+json' },
    });
  },
  LoadReservationSign(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservationLecture/LoadReservationSign',
      params,
    });
  },
  // load讀卡機簽到的學生名單
  LoadDateReservationSign(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_StudentReservationLecture/LoadDateReservationSign',
      params,
    });
  },
  CardSignup(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_StudentReservationLecture/CardSignup',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
};
